
export async function createTestimonial(testimonial) {
    try {
        const API = process.env.REACT_APP_BACKEND_API;
        const response = await fetch(`${API}/api/testimonial/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(testimonial),
        });
        return response;
    } catch (error) {
        console.error('Error creating testimonial:', error);
        return { error: 'Failed to create testimonial' };
    }
}

export async function getTestimonials() {
    try {
        const API = process.env.REACT_APP_BACKEND_API;
        const response = await fetch(`${API}/api/testimonial`);
        return response;
    } catch (error) {
        console.error('Error fetching testimonials:', error);
        return { error: 'Failed to fetch testimonials' };
    }
}
